import { getApiBaseUrl } from '../utils/apiBaseUrl';

export interface DeleteFeedbackResponse {
  message: string;
}

export const deleteFeedbackAdmin = async (
  id: number,
  token: string
): Promise<DeleteFeedbackResponse> => {
  const baseUrl = getApiBaseUrl();

  const response = await fetch(`${baseUrl}/api/Feedback/delete/${id}`, {
    method: "DELETE",
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    },
  });

  if (!response.ok) {
    throw new Error(`Failed to delete feedback: ${response.status}`);
  }

  const data: DeleteFeedbackResponse = await response.json();
  return data;
};